import React, { useContext, useEffect, useState } from 'react'
import Breadcrumb from '../../Component/Breadcrumb'
import { toast } from 'react-toastify';
import { MyContext } from '../../hooks/useContextProvider';
import useBreakPoints from '../../hooks/useBreakPoints';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Modal, Input } from "@mui/material";
import { Plus, X } from "lucide-react";
import InputRange from "react-input-range";

const styles = {
  item: {
    display: "flex",
    gap: 10,
    marginBottom: "20px",
  },
  image: {
    width: "60px",
    height: "60px",
    marginRight: "20px",
    border: "1px solid #ddd",
  },
  itemDetails: {
    flex: 1,
  },
  itemName: {
    fontWeight: "bold",
    marginBottom: "5px",
    lineHeight: "20px",
  },
  itemMeta: {
    color: "#666",
    fontSize: "14px",
  },
  itemMetaTime: {
    color: "#000",
    fontSize: "14px",
  },
  itemPrice: {
    fontWeight: "bold",
  },
  discountContainer: {
    display: "flex",
    marginBottom: "20px",
  },
  input: {
    flex: 1,
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "4px 0 0 4px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#f0f0f0",
    border: "1px solid #ddd",
    borderLeft: "none",
    borderRadius: "0 4px 4px 0",
    cursor: "pointer",
  },
  subtotal: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  shipping: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  total: {
    display: "flex",
    justifyContent: "space-between",
    fontWeight: "bold",
    fontSize: "18px",
  },

  row: {
    display: "flex",
    alignItems: "flex-start",
    padding: "15px 0",
    borderBottom: "1px solid #e0e0e0",
    flexDirection: "column",
  },
  //   selectedRow: {
  //     backgroundColor: "#f0f7ff",
  //   },
  radio: {
    marginRight: "15px",
    width: "max-content",
  },
  name: {
    fontWeight: "bold",
    marginRight: "10px",
  },
  label: {
    backgroundColor: "#e0e0e0",
    padding: "2px 6px",
    borderRadius: "4px",
    fontSize: "12px",
    marginRight: "10px",
  },
  phone: {
    color: "#666",
    marginRight: "10px",
  },
  address: {
    color: "#666",
    fontSize: "14px",
    flex: 1,
    paddingLeft: 30,
  },
  edit: {
    color: "#1a73e8",
    fontWeight: "bold",
    cursor: "pointer",
  },
  range_slider: {
    width: "100%",
    height: "6px",
  }
};
const Checkout = () => {
  const { cartList, callCartDetails, callCustomerDetails, userContaxtDetails } = useContext(MyContext);
  console.log('userContaxtDetails: ', userContaxtDetails);
  let userInfo = JSON.parse(localStorage?.getItem("userDetails"));
  const { isTablet, isMobile } = useBreakPoints();
  const navigate = useNavigate();
  const [step, setStep] = useState("step1");
  const [couponCode, setCouponCode] = useState("");
  const [loading, setloading] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [finalAmount, setFinalAmount] = useState();
  const [discountAmount, setDiscountAmount] = useState(0);
  console.log('discountAmount123: ', discountAmount);
  const [couponApply, setCouponApply] = useState(false);
  console.log("discountAmount: ", discountAmount);
  console.log("finalAmount: ", finalAmount);
  const [shippingCharges, setShippingCharges] = useState(0);
  const [subTotal, setSubTotal] = useState();
  const [selectedAddress, setSelectedAddress] = useState();
  console.log('selectedAddress: ', selectedAddress);
  const activeTab = 1;
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [editAddressModal, setEditAddressModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("onlinePayment");
  const [gst, setGst] = useState(0);

  const [addressInputData, setAddressInputData] = useState({
    address: "",
    city: "",
    state: "",
    pincode: "",
    country: "India",
  });
  const [addressInputDataError, setAddressInputDataError] = useState({
    address: false,
    city: false,
    state: false,
    pincode: false,
    country: false,
  });

  const [useWalletBalance, setUseWalletBalance] = useState(false);
  console.log('useWalletBalance: ', useWalletBalance);
  const [walletAmountToUse, setWalletAmountToUse] = useState(0);
  console.log('walletAmountToUse: ', walletAmountToUse);
  const [walletDiscountAmount, setWalletDiscountAmount] = useState(0);
  console.log('walletDiscountAmount: ', walletDiscountAmount);
  const [rewardSettings, setRewardSettings] = useState([]);



  const callAddressListApi = async () => {
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    let formData = new FormData();
    formData.append("customerId", userInfo?.id);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}addressesbycustomer?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          if (data?.addressList?.length === 0) {
            setAlertModal(true);
            setloading(false);
          } else {
            setAddressList(data?.addressList);
            setSelectedAddress(data?.addressList?.[0]);
            callShippingCharges(data?.addressList?.[0]?.customerPincode);
          }
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const callShippingCharges = async (pincode) => {
    let formData = new FormData();
    formData.append("customerPostalCode", pincode);
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}getshippingcharge?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          if (data?.shippingPrice) {
            setShippingCharges(data?.shippingPrice);

            // setFinalAmount(total.toFixed(2));
          } else {
            setShippingCharges(0);
          }
          setloading(false);
        } else {
          setloading(false);
          // toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });


  };

  // const recalculateFinalAmount = (couponDiscount, walletDiscount) => {
  //   console.log('walletDiscount_f: ', walletDiscount);
  //   console.log('couponDiscount_f: ', couponDiscount);
  //   console.log('gst_f: ', gst);
  //   console.log('shippingCharges_f: ', shippingCharges);
  //   console.log('subTotal_f: ', subTotal);
  //   const total = +subTotal + +shippingCharges - couponDiscount - walletDiscount;
  //   const withGstTotal = parseFloat(total) + parseFloat(gst)
  //   setFinalAmount(withGstTotal.toFixed(2));
  // };

  const recalculateFinalAmount = (couponDiscount, walletDiscount) => {
    console.log('walletDiscount_f: ', walletDiscount);
    console.log('couponDiscount_f: ', couponDiscount);
    console.log('gst_f: ', gst);
    console.log('shippingCharges_f: ', shippingCharges);
    console.log('subTotal_f: ', subTotal);
    const total = +subTotal + +shippingCharges - couponDiscount - walletDiscount;
    setFinalAmount(total.toFixed(2));
  };

  const callRewardSettings = async () => {

    const requestOptions = {
      method: "GET",
    };
    fetch(
      `${process.env.REACT_APP_API_URL}rewardsettings`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setRewardSettings(data?.rewardSettingList);

        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  // useEffect(() => {
  //   const total = cartList
  //     ?.reduce((acc, item) => {
  //       console.log('item2703: ', item);
  //       const price = parseFloat(item.variantDetails?.price);
  //       const qty = parseInt(item.qty);

  //       // Calculate discounted price
  //       const discountedPrice =
  //         item.productDetails?.isDiscountApplicable === "true"
  //           ? price - (price * parseFloat(item.productDetails?.discountedPercentage)) / 100
  //           : price;

  //       // Calculate price for the item including quantity
  //       return acc + qty * discountedPrice;
  //     }, 0)
  //     .toFixed(2);

  //   // Calculate GST (18%)
  //   const gstAmount = (parseFloat(total) * 0.18).toFixed(2);
  //   setGst(gstAmount)

  //   // Set subtotal
  //   setSubTotal(total);

  //   // Set final amount including shipping and GST
  //   setFinalAmount(
  //     (parseFloat(total) + parseFloat(shippingCharges) + parseFloat(gstAmount)).toFixed(2)
  //   );
  // }, [cartList, shippingCharges]);

  useEffect(() => {
    const total = cartList
      ?.reduce((acc, item) => {
        console.log('item2703: ', item);
        const price = parseFloat(item.variantDetails?.price);
        const qty = parseInt(item.qty);

        // Calculate discounted price
        const discountedPrice =
          item.productDetails?.isDiscountApplicable === "true"
            ? price - (price * parseFloat(item.productDetails?.discountedPercentage)) / 100
            : price;

        // Calculate price for the item including quantity
        return acc + qty * discountedPrice;
      }, 0)
      .toFixed(2);

    setSubTotal(total);

    setFinalAmount(
      (parseFloat(total) + parseFloat(shippingCharges)).toFixed(2)
    );
  }, [cartList, shippingCharges]);

  useEffect(() => {

    callCartDetails();
    callAddressListApi();
    callCustomerDetails();
    callRewardSettings();
  }, []);

  const handleSubmitAddAddress = async (e) => {
    e.preventDefault();

    if (!addressInputData?.address) {
      toast?.error("Please Enter a Address!", { toastId: "addressErr" });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (addressInputData?.address?.length <= 2) {
      toast?.error("Please Enter a Proper Address!", {
        toastId: "addressErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (!addressInputData?.city) {
      toast?.error("Please Enter a City!", { toastId: "cityErr" });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (addressInputData?.city?.length <= 2) {
      toast?.error("Please Enter a Proper City!", {
        toastId: "cityErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (!addressInputData?.state) {
      toast?.error("Please Enter a State!", { toastId: "stateErr" });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (addressInputData?.state?.length <= 2) {
      toast?.error("Please Enter a Proper State!", {
        toastId: "stateErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (!addressInputData?.country) {
      toast?.error("Please Enter a Country!", { toastId: "countryErr" });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (addressInputData?.country?.length <= 2) {
      toast?.error("Please Enter a Proper Country!", {
        toastId: "countryErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (!addressInputData?.pincode) {
      toast?.error("Please Enter a Pincode!", { toastId: "pincodeErr" });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else if (addressInputData?.pincode?.length !== 6) {
      toast?.error("Please Enter a Proper Pincode!", {
        toastId: "pincodeErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else {
      setloading(true);
      let formData = new FormData();
      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("customerAddress", addressInputData?.address);
      formData.append("customerCity", addressInputData?.city);
      formData.append("customerState", addressInputData?.state);
      formData.append("customerPincode", addressInputData?.pincode);
      formData.append("customerCountry", addressInputData?.country);
      formData.append("created_by", userInfo?.customerName);
      console.log("formData: ", formData);

      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addcustomeraddress?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setOpenModal(false);
            setAddressInputData({
              address: "",
              city: "",
              state: "",
              pincode: "",
              country: "",
            });

            callAddressListApi();
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const handleEditAddressModal = (data) => {
    setEditAddressModal(true);
    setSelectedId(data?.id);
    setAddressInputData({
      ...addressInputData,
      address: data?.customerAddress,
      city: data?.customerCity,
      state: data?.customerState,
      country: data?.customerCountry,
      pincode: data?.customerPincode,
    });
  };

  const handleUpdateAddAddress = async (e) => {
    e.preventDefault();

    if (!addressInputData?.address) {
      toast?.error("Please Enter a Address!", { toastId: "addressErr" });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (addressInputData?.address?.length <= 2) {
      toast?.error("Please Enter a Proper Address!", {
        toastId: "addressErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (!addressInputData?.city) {
      toast?.error("Please Enter a City!", { toastId: "cityErr" });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (addressInputData?.city?.length <= 2) {
      toast?.error("Please Enter a Proper City!", {
        toastId: "cityErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (!addressInputData?.state) {
      toast?.error("Please Enter a State!", { toastId: "stateErr" });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (addressInputData?.state?.length <= 2) {
      toast?.error("Please Enter a Proper State!", {
        toastId: "stateErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (!addressInputData?.country) {
      toast?.error("Please Enter a Country!", { toastId: "countryErr" });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (addressInputData?.country?.length <= 2) {
      toast?.error("Please Enter a Proper Country!", {
        toastId: "countryErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (!addressInputData?.pincode) {
      toast?.error("Please Enter a Pincode!", { toastId: "pincodeErr" });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else if (addressInputData?.pincode?.length !== 6) {
      toast?.error("Please Enter a Proper Pincode!", {
        toastId: "pincodeErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else {
      setloading(true);
      let formData = new FormData();
      formData.append("customerId", userInfo?.id);
      formData.append("id", selectedId);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("customerAddress", addressInputData?.address);
      formData.append("customerCity", addressInputData?.city);
      formData.append("customerState", addressInputData?.state);
      formData.append("customerPincode", addressInputData?.pincode);
      formData.append("customerCountry", addressInputData?.country);
      formData.append("updated_by", userInfo?.customerName);
      console.log("formData: ", formData);

      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}editcustomeraddress?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setEditAddressModal(false);
            setSelectedId("");
            setAddressInputData({
              address: "",
              city: "",
              state: "",
              pincode: "",
              country: "",
            });

            callAddressListApi();
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const handleSubmitCheckout = async (e) => {
    e.preventDefault();

    if (paymentMethod === "onlinePayment") {
      handlePayment(e);
    } else if (paymentMethod === "cashOnDelivery") {
      handleSubmitOrder();
    }
  };

  const handleSubmitOrder = async (razorpayData) => {
    setloading(true);
    console.log(cartList, "++++++++++++++++++");

    let formData = new FormData();

    let arr = [];

    cartList?.map((er) => {
      arr?.push({
        amount: +er?.qty * +er?.variantDetails?.price,
        product: { value: er?.productDetails?.id },
        vendor: { value: er?.productDetails?.vendorId },
        qty: er?.qty,
        variant: {
          value: er?.variantDetails?.id,
          varientKey: er?.variantDetails?.variantkey,
          price: er?.variantDetails?.price,
          attributeDetails: er?.attributeDetails?.id,
        },
      });
    });
    console.log('productListArr: ', arr);
    formData.append("customerId", userInfo?.id);
    formData.append("shippingAmount", shippingCharges);
    formData.append("totalAmount", subTotal);
    if (couponCode !== "") {
      formData.append("offerCouponCode", couponCode);
    }
    formData.append("netAmount", finalAmount);

    if (razorpayData?.payment_type) {
      formData.append("paymentType", razorpayData?.payment_type);
    } else {
      formData.append("paymentType", paymentMethod);
    }
    formData.append("created_by", userInfo?.customerName);
    formData.append("customerAddressId", +selectedAddress?.id);
    formData.append("productList", JSON.stringify(arr));

    if (razorpayData?.razorpay_order_id) {
      formData.append("razorpayOrderId", razorpayData?.razorpay_order_id);
    }

    if (razorpayData?.razorpay_payment_id) {
      formData.append("transectionId", razorpayData?.razorpay_payment_id);
    }
    if (razorpayData?.payment_status) {
      formData.append("paymentStatus", razorpayData?.payment_status);
    }
    if (razorpayData?.razorpay_signature) {
      formData.append("transectionSignature", razorpayData?.razorpay_signature);
    }
    if (razorpayData?.transaction_time) {
      formData.append("transectionTime", razorpayData?.transaction_time);
    }

    if (useWalletBalance === true) {
      formData.append("userRewardDiscount", "True");
      formData.append("usedCoins", walletAmountToUse);
      formData.append("walletDiscountAmount", walletDiscountAmount);
    }
    formData.append("couponDiscountAmount", discountAmount);
    formData.append("gst", gst);

    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}addcustomerorder?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          setloading(false);
          setStep("step2");
          callCartDetails();
          callCustomerDetails();
          toast.success("Order Added Succesfully");
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const handlePayment = async (e) => {
    e.preventDefault();
    try {
      let formData = new FormData();

      console.log("finalAmount: ", finalAmount);
      formData.append("totalAmount", parseInt(finalAmount));

      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}razorpaycreateorder?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            console.log("apiCall: ", data);
            handleOpenRazorpay(data);
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    } catch (error) {
      console.log(error);
      // toast.error(error);
    }
  };

  const handleOpenRazorpay = (data) => {
    const option = {
      key: "rzp_test_gaPGn4cvxy0XAV",

      data: data.amount,
      currency: data.currency,
      name: userInfo?.company_name,
      description: "",
      // image: Logo,
      order_id: data.razorpay_order_id,
      prefill: {
        name: userInfo?.customerName,
        email: userInfo?.customerEmail,
        contact: userInfo?.customerMobile,
      },
      handler: async function (response) {
        console.log("response: ", response);

        try {
          let formData = new FormData();

          formData.append("razorpay_payment_id", response.razorpay_payment_id);
          formData.append("razorpay_order_id", response.razorpay_order_id);
          formData.append("razorpay_signature", response.razorpay_signature);

          let token = localStorage.getItem("token");
          let ipAddress = localStorage.getItem("ipaddress");

          const requestOptions = {
            method: "POST",
            body: formData,
            headers: {
              Authorization: `Token ${token}`,
            },
          };
          fetch(
            `${process.env.REACT_APP_API_URL}verifypayment?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
            requestOptions
          )
            .then((response) => response.json())
            .then((data) => {
              if (
                data &&
                (data.detail === "The Token is expired" ||
                  data.message === "Invalid token" || data.message === "Invalid Credentials.")
              ) {
                localStorage.clear();
                navigate("/");
                window.location.reload();
              }
              if (data && data.status) {
                console.log("apiCall: ", data);

                handleSubmitOrder({
                  razorpay_order_id: data?.razorpay_order_id,
                  razorpay_payment_id: data?.razorpay_payment_id,
                  payment_status: data?.payment_status,
                  razorpay_signature: data?.razorpay_signature,
                  transaction_time: data?.transaction_time,
                  payment_type: data?.payment_type,
                });
              } else if (data.message !== "Invalid token") {
                setloading(false);
                toast.error(data?.message);
              }
            })
            .catch((error) => {
              setloading(false);
              setTimeout(() => {
                toast.error("AA2 There was an error, Please try again later.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }, 1000);
            });

          // const apiCall = await paymentVerifyApi(formData);
          // console.log("apiCall: ", apiCall);
          // if (apiCall.status) {
          //   console.log("apiCall: ", apiCall);

          // handleSubmitOrder({
          //   razorpay_order_id: apiCall?.razorpay_order_id,
          //   razorpay_payment_id: apiCall?.razorpay_payment_id,
          //   payment_status: apiCall?.payment_status,
          //   razorpay_signature: apiCall?.razorpay_signature,
          //   transaction_time: apiCall?.transaction_time,
          //   payment_type: apiCall?.payment_type,
          // });
          // } else {
          //   toast.error(apiCall.message);
          // }
        } catch (error) {
          console.log(error);
        }
      },
    };

    const rzp = new window.Razorpay(option);
    rzp.open();
  };

  const handleApplyCouponCode = (e) => {
    let formData = new FormData();
    formData.append("couponCode", couponCode);
    formData.append("purchaseAmount", subTotal);
    formData.append("clientId", process.env.REACT_APP_Client_Id);
    formData.append("created_by", process.env.REACT_APP_Client_Id);

    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}checkoffercouponvalidity?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          setDiscountAmount(data?.discountValue);
          setCouponApply(true);
          setFinalAmount(
            parseFloat(finalAmount - data?.discountValue).toFixed(2)
          );

          setloading(false);
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };


  return (
    <>
      <Breadcrumb mainTitle={"Checkout"} title={"Checkout"} subTitle={"Home"} />

      {step === "step1" && (
        <div className="grid-container" style={{ gridTemplateRows: isMobile && "repeat(auto-fit, minmax(150px, 1fr))" }}>
          <div
            data-aos="slide-right"
            data-aos-delay=""
            className="aos-initgrid-item"
          >

            <section>
              <div
                style={{
                  maxWidth: "600px",
                  margin: isTablet ? "0px auto" : "0px 45px 0px auto",
                  padding: "20px",
                }}
              >
                <div className="accordion -simple row y-gap-20 js-accordion">
                  <div className="col-12">
                    <div
                      className={`accordion__item px-20 py-15 border-1 rounded-12 ${activeTab === 1 ? "is-active" : ""
                        }`} style={{ padding: "20px 15px", border: "1px solid #e7e6e6 ", borderRadius: 12 }}
                    >
                      <div className="accordion__button d-flex items-center justify-between" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div className=" text-16 text-dark-1" >
                          <p
                            style={{
                              fontSize: 18,
                              color: "black",
                              fontWeight: 600,
                              marginBottom: 0
                            }}
                          >
                            Delivery
                          </p>
                        </div>
                        <div
                          onClick={() => {
                            setOpenModal(true);
                            setAddressInputData({
                              address: "",
                              city: "",
                              state: "",
                              pincode: "",
                              country: "India",
                            });
                          }}
                          className="accordion__icon size-30 flex-center bg-light-2 rounded-full"
                        >
                          <Plus size={16} color='black' />
                          <Plus size={16} color='black' />
                        </div>
                      </div>
                      <div
                        className="accordion__content"
                        style={{
                          maxHeight: activeTab === 1 && 439,
                          overflow: activeTab === 1 && "auto",
                          height: activeTab === 1 && "100%",
                        }}
                      >
                        <div className="pt-20" style={{ paddingRight: 20 }}>
                          {addressList?.map((item, i) => (
                            <div
                              onClick={(e) => {
                                setSelectedAddress(item);
                                callShippingCharges(item?.customerPincode)
                              }}
                              style={{ ...styles.row, cursor: "pointer" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <div>
                                  <input
                                    type="radio"
                                    name="contact"
                                    checked={selectedAddress?.id === item?.id}
                                    style={styles.radio}
                                  />
                                  <span style={styles.name}>
                                    {item?.customerDetails?.customerName}
                                  </span>
                                  <span style={styles.label}>HOME</span>
                                  <span style={styles.phone}>
                                    {item?.customerDetails?.customerMobile}
                                  </span>
                                </div>

                                <div>
                                  <i
                                    onClick={() => {
                                      handleEditAddressModal(item);
                                    }}
                                    class="fi fi-br-edit"
                                    style={{ color: "#32ba7c" }}
                                  ></i>
                                </div>
                              </div>
                              <span style={styles.address}>
                                {item?.customerAddress},{item?.customerCity},
                                {item?.customerState},{item?.customerPincode},
                                {item?.customerCountry}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

          </div>
          <div
            data-aos="slide-left"
            data-aos-delay=""
            className="aos-init grid-item"
            style={{
              borderLeft: !isMobile && "1px solid #dfdfdf",
              borderTop: isMobile && "1px solid #dfdfdf",
            }}
          >
            <div
              style={{
                maxWidth: isTablet ? 600 : "400px",
                margin: isTablet ? "0px auto" : "0px auto 0px 45px",
                padding: "20px",
              }}
            >
              {cartList?.map((item, i) => {
                return (
                  <div key={i} style={styles.item}>
                    <div style={styles.image}>
                      <img
                        src={
                          JSON.parse(
                            item?.variantDetails?.variantImageGallery?.replace(
                              /'/g,
                              '"'
                            ) || "[]"
                          )[0]
                        }
                        alt="Engagement Ring"
                        style={{ height: 64, width: 64 }}
                      />
                    </div>
                    <div style={styles.itemDetails}>
                      <div style={styles.itemName}>
                        {item?.productDetails?.productName}
                      </div>
                      <div style={styles.itemMeta}>
                        {item?.productDetails?.subCategory}
                      </div>
                      <div style={styles.itemMeta}>
                        {" "}
                        {item?.variantDetails?.id && (
                          <>
                            {item?.variantDetails?.variantkey?.split("-")[0]}{" "}

                            {item?.variantDetails?.variantkey?.split("-")?.[1] && (`- ${item?.variantDetails?.variantkey?.split("-")?.[1]}`)}
                            {item?.variantDetails?.variantkey?.split("-")?.[2] && (`- ${item?.variantDetails?.variantkey?.split("-")?.[2]}`)}

                          </>
                        )}
                      </div>
                      <div style={styles.itemMetaTime}>
                        Arriving in: {item?.productDetails?.expectedDeliveryTime}
                      </div>

                    </div>
                    <div style={styles.itemPrice}>
                      ₹{" "}
                      {parseFloat(
                        (item?.productDetails?.discountedPercentage
                          ? parseFloat(
                            parseFloat(item?.variantDetails?.price) -
                            (item?.variantDetails?.price *
                              item?.productDetails
                                ?.discountedPercentage) /
                            100
                          ).toFixed(2)
                          : +parseInt(item?.variantDetails?.price)) *
                        +item?.qty
                      ).toFixed(2)}
                    </div>
                  </div>
                );
              })}

              <div style={styles.discountContainer}>
                <div
                  className=""
                  style={{ width: "100%", position: "relative" }}
                >
                  <input
                    style={styles.input}
                    type="text"
                    disabled={couponApply}
                    value={couponCode}
                    onChange={(e) =>
                      setCouponCode(e.target.value.toUpperCase())
                    }
                    placeholder="Discount code or gift card"
                  />

                  {/* {couponApply && (
                    <X
                      size={24}
                      color='black'
                      style={{ position: "absolute", right: 10, top: 14 }}
                      onClick={() => {
                        setFinalAmount(+subTotal + +shippingCharges + parseFloat(gst) - parseFloat(walletDiscountAmount));
                        setCouponCode("");
                        setCouponApply(false);
                        setDiscountAmount(0);
                      }}
                    />
                  )} */}
                  {couponApply && (
                    <X
                      size={24}
                      color='black'
                      style={{ position: "absolute", right: 10, top: 14 }}
                      onClick={() => {
                        setFinalAmount(+subTotal + +shippingCharges - parseFloat(walletDiscountAmount));
                        setCouponCode("");
                        setCouponApply(false);
                        setDiscountAmount(0);
                      }}
                    />
                  )}
                </div>
                <button
                  style={{ ...styles.button, marginTop: 0, color: "black" }}
                  disabled={couponApply}
                  onClick={(e) => {
                    handleApplyCouponCode();
                  }}
                >
                  Apply
                </button>
              </div>

              <div style={styles.subtotal}>
                <span>Subtotal (Including GST)</span>
                <span>₹{subTotal}</span>
              </div>
              <div style={styles.subtotal}>
                <span>Shipping Charges</span>
                <span>₹{shippingCharges}</span>
              </div>
              <div style={styles.subtotal}>
                <span>Discount</span>
                <span>-₹{discountAmount}</span>
              </div>
              {/* <div style={styles.subtotal}>
                <span>GST 18%</span>
                <span>₹{gst}</span>
              </div> */}

              {/* Wallet Balance Use Option */}
              <div style={{ marginTop: "15px", marginBottom: "15px", border: "1px solid #e7e6e6", borderRadius: "8px", padding: "12px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="checkbox"
                      id="useWallet"
                      checked={useWalletBalance}
                      onChange={(e) => {
                        // Check if order meets minimum amount requirement
                        if (e.target.checked && (subTotal <= parseInt(rewardSettings[0]?.min_purchase_for_redemption))) {
                          toast.error(`Minimum order amount of ₹${rewardSettings[0]?.min_purchase_for_redemption} is required to redeem coins`);
                          return;
                        }

                        // Check if wallet has minimum required balance
                        if (e.target.checked && ((userContaxtDetails?.customerWalletBalance) <= parseInt(rewardSettings[0]?.min_points_to_redeem))) {
                          toast.error(`More Than ${rewardSettings[0]?.min_points_to_redeem} coins required in wallet to redeem`);
                          return;
                        }

                        setUseWalletBalance(e.target.checked);
                        if (!e.target.checked) {
                          setWalletAmountToUse(0);
                          setWalletDiscountAmount(0);
                          recalculateFinalAmount(discountAmount, 0);
                        }
                      }}
                      style={{ marginRight: "10px", cursor: "pointer" }}
                    />
                    <label htmlFor="useWallet" style={{ cursor: "pointer", fontWeight: "500", marginBottom: "0" }}>
                      Use Reward Coins
                    </label>
                  </div>
                  <div style={{ fontSize: "14px", color: "#666" }}>
                    Available: {userContaxtDetails?.customerWalletBalance} Coins
                  </div>
                </div>

                {useWalletBalance && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ width: "70%" }}>
                          <InputRange
                            type="number"
                            maxValue={Math.min(
                              parseInt(userContaxtDetails?.customerWalletBalance) - parseInt(rewardSettings[0]?.min_points_to_redeem),
                              parseInt(rewardSettings[0]?.maxRedemptionAmount)
                            )}
                            minValue={0}
                            value={walletAmountToUse}
                            onChange={(e) => {
                              const coinAmount = Math.min(
                                parseFloat(e),
                                Math.min(rewardSettings[0]?.maxRedemptionAmount)
                              );
                              const moneyAmount = coinAmount / parseInt(rewardSettings[0]?.points_to_currency_ratio); // 10 Coins = ₹1
                              setWalletAmountToUse(coinAmount);
                              setWalletDiscountAmount(moneyAmount);
                              recalculateFinalAmount(discountAmount, moneyAmount);
                            }}
                          />
                        </div>
                        <div style={{ width: "28%" }}>
                          <input
                            type="number"
                            min="0"
                            max={Math.min(
                              parseInt(userContaxtDetails?.customerWalletBalance) - parseInt(rewardSettings[0]?.min_points_to_redeem),
                              parseInt(rewardSettings[0]?.maxRedemptionAmount)
                            )}
                            value={walletAmountToUse}
                            onChange={(e) => {
                              const coinAmount = Math.min(
                                parseFloat(e.target.value),
                                Math.min(
                                  parseInt(userContaxtDetails?.customerWalletBalance) - parseInt(rewardSettings[0]?.min_points_to_redeem),
                                  parseInt(rewardSettings[0]?.maxRedemptionAmount)
                                )
                              );
                              const moneyAmount = coinAmount / parseInt(rewardSettings[0]?.points_to_currency_ratio);
                              setWalletAmountToUse(coinAmount);
                              setWalletDiscountAmount(moneyAmount);
                              recalculateFinalAmount(discountAmount, moneyAmount);
                            }}
                            style={{
                              width: "100%",
                              padding: "8px",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              fontSize: "14px"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ fontSize: "12px", color: "#666", marginTop: "8px" }}>
                      <div>• {walletAmountToUse} Coins = ₹{walletDiscountAmount.toFixed(2)}</div>
                      <div>• Conversion: {rewardSettings[0]?.points_to_currency_ratio} Coins = ₹1</div>
                    </div>
                  </>
                )}

                <div style={{ fontSize: "12px", color: "#666", marginTop: "10px", borderTop: "1px solid #eee", paddingTop: "10px" }}>
                  <div>• Minimum order value: ₹ {rewardSettings[0]?.min_purchase_for_redemption}</div>
                  <div>• Minimum wallet balance: {rewardSettings[0]?.min_points_to_redeem} Coins</div>
                  <div>• Maximum redemption: {rewardSettings[0]?.maxRedemptionAmount} Coins</div>
                </div>
              </div>

              {walletDiscountAmount > 0 && (
                <div style={styles.subtotal}>
                  <span>Reward Coins Applied ({walletAmountToUse} Coins)</span>
                  <span>-₹{walletDiscountAmount.toFixed(2)}</span>
                </div>
              )}

              <div style={styles.total}>
                <span>Total</span>
                <span>INR ₹ {finalAmount}</span>
              </div>

              <div className="mt-20">
                <h6>Choose your payment method</h6>

                <div className="d-flex justify-content-start align-items-center ">
                  <input
                    type="radio"
                    checked={paymentMethod === "onlinePayment"}
                    onChange={(e) => {
                      setPaymentMethod("onlinePayment");
                    }}
                    style={{ width: "max-content", cursor: "pointer", margin: "0px 16px" }}
                  />
                  <label className="mx-3" style={{ marginTop: 1 }}>
                    Online Payment
                  </label>
                </div>
                <div className="d-flex justify-content-start align-items-center ">
                  <input
                    type="radio"
                    checked={paymentMethod === "cashOnDelivery"}
                    style={{ width: "max-content", cursor: "pointer", margin: "0px 16px " }}
                    onChange={(e) => {
                      setPaymentMethod("cashOnDelivery");
                    }}
                  />
                  <label className="mx-3" style={{ marginTop: 1 }}>
                    Cash on Delivery
                  </label>
                </div>
              </div>

              {
                paymentMethod === "cashOnDelivery" && (
                  <button
                    style={{
                      backgroundColor: "#00264d",
                      color: "white",
                      border: "none",
                      padding: "15px",
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: 8,
                      cursor: "pointer",
                      marginBottom: "10px",
                      marginTop: "40px",
                    }}
                    type="button"
                    onClick={(e) => {
                      handleSubmitCheckout(e);
                    }}
                  >
                    Place Order
                  </button>
                )
              }
              {
                paymentMethod === "onlinePayment" && (
                  <button
                    style={{
                      backgroundColor: "#00264d",
                      color: "white",
                      border: "none",
                      padding: "15px",
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: 8,
                      cursor: "pointer",
                      marginBottom: "10px",
                      marginTop: "40px",
                    }}
                    type="button"
                    onClick={(e) => {
                      handleSubmitCheckout(e);
                    }}
                  >
                    Pay Now
                  </button>
                )
              }

              {/* <button
                style={{
                  backgroundColor: "#00264d",
                  color: "white",
                  border: "none",
                  padding: "15px",
                  width: "100%",
                  fontSize: "16px",
                  fontWeight: "bold",
                  borderRadius: 8,
                  cursor: "pointer",
                  marginBottom: "10px",
                  marginTop: "40px",
                }}
                type="button"
                onClick={(e) => {
                  handleSubmitCheckout(e);
                }}
              >
                Pay Now
              </button> */}
            </div>
          </div>
        </div>
      )}


      {step === "step2" && (
        <div className="wrapperAlert">
          <div className="contentAlert">
            <div className="topHalf">
              <p>
                <svg className='custom-cart-svg' viewBox="0 0 512 512" width="100" title="check-circle">
                  <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" />
                </svg>
              </p>
              {/* <h1 className="text-white mt-4">Congratulations</h1> */}
              <h2 className="text-white mt-4" style={{ color: "white" }}>
                Your Order Placed Successfully
              </h2>
              <h6 className="text-white" style={{ color: "white" }}>Thank You So Much for Your Order.</h6>

              <ul className="bg-bubbles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>

            <button
              id="alertMO"
              className="mt-4"
              style={{ cursor: "pointer", marginTop: 20 }}
              onClick={() => {
                navigate("/shop");
              }}
            >
              Continue Shopping
            </button>
          </div>
        </div>
      )}

      {openModal && (
        <Modal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              position: "absolute",
              flexDirection: "column",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxWidth: 800,
              width: "90%",
              borderRadius: 2,
              border: "none",
              outline: "none",
              background: "white",
            }}
          >
            <div
              style={{
                textAlign: "left",
                backgroundColor: "rgb(0, 38, 77)",
                color: "white",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                padding: "0px 20px",
              }}
              className='cust-modal-header'
            >
              <h3 className="jost-font p-2 text-white">Add New Address</h3>

              <IconButton
                aria-label="close"
                onClick={() => setOpenModal(false)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 15,

                }}
              >
                <i
                  className="fa fa-close "
                  style={{ fontSize: 25, color: "white" }}
                ></i>
              </IconButton>
            </div>

            <div style={{ width: "100%", padding: 33 }}>
              <form className="row" onSubmit={(e) => handleSubmitAddAddress(e)}>
                <div className="col-md-12 ">
                  {" "}
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={addressInputData?.address}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        address: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          address: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          address: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.address ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6">
                  {" "}
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={addressInputData?.city}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        city: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          city: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          city: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.city ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6 pl-0 ">
                  {" "}
                  <input
                    type="text"
                    name="pinCode"
                    placeholder="State"
                    value={addressInputData?.state}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        state: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          state: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          state: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.state ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6">
                  {" "}
                  <input
                    type="number"
                    name="pinCode"
                    placeholder="PIN code"
                    value={addressInputData?.pincode}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        pincode: e.target.value,
                      });

                      if (e.target.value.length === 6) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          pincode: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          pincode: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.pincode ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6 pl-0 ">
                  {" "}
                  <select
                    name="country"
                    value={addressInputData?.country}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        country: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          country: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          country: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.country ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                      appearance: "none",
                      backgroundImage:
                        'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 10px top 50%",
                      backgroundSize: "12px auto",
                    }}
                  >
                    <option value="India">India</option>
                  </select>
                </div>{" "}
                <div className="d-flex justify-end">
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#00264d",
                      color: "white",
                      border: "none",
                      padding: "15px",
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: 8,
                      cursor: "pointer",
                      marginBottom: "10px",
                      marginTop: "40px",
                      maxWidth: 220,
                    }}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </Box>
        </Modal>
      )}

      {editAddressModal && (
        <Modal
          open={editAddressModal}
          onClose={() => {
            setEditAddressModal(false);
          }}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              position: "absolute",
              flexDirection: "column",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxWidth: 800,
              width: "90%",
              borderRadius: 2,
              border: "none",
              outline: "none",
              background: "white",
            }}
          >
            <div
              style={{
                textAlign: "left",
                backgroundColor: "rgb(0, 38, 77)",
                color: "white",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                padding: "0px 20px",

              }}
              className='cust-modal-header'
            >
              <h3 className="jost-font p-2 text-white">Update Address</h3>

              <IconButton
                aria-label="close"
                onClick={() => setEditAddressModal(false)}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 15,
                }}
              >
                <i
                  className="fa fa-close "
                  style={{ fontSize: 25, color: "white" }}
                ></i>
              </IconButton>
            </div>

            <div style={{ width: "100%", padding: 33 }}>
              <form className="row" onSubmit={(e) => handleUpdateAddAddress(e)}>
                <div className="col-md-12 ">
                  {" "}
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={addressInputData?.address}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        address: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          address: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          address: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.address ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6">
                  {" "}
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={addressInputData?.city}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        city: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          city: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          city: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.city ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6 pl-0 ">
                  {" "}
                  <input
                    type="text"
                    name="pinCode"
                    placeholder="State"
                    value={addressInputData?.state}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        state: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          state: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          state: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.state ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6">
                  {" "}
                  <input
                    type="number"
                    name="pinCode"
                    placeholder="PIN code"
                    value={addressInputData?.pincode}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        pincode: e.target.value,
                      });

                      if (e.target.value.length === 6) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          pincode: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          pincode: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.pincode ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6 pl-0 ">
                  {" "}
                  <select
                    name="country"
                    value={addressInputData?.country}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        country: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          country: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          country: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.country ? "1px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                      appearance: "none",
                      backgroundImage:
                        'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 10px top 50%",
                      backgroundSize: "12px auto",
                    }}
                  >
                    <option value="India">India</option>
                  </select>
                </div>{" "}
                <div className="" style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#00264d",
                      color: "white",
                      border: "none",
                      padding: "15px",
                      width: "100%",
                      fontSize: "18px",
                      borderRadius: 8,
                      cursor: "pointer",
                      marginBottom: "10px",
                      marginTop: "40px",
                      maxWidth: 220,
                    }}
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </Box>
        </Modal>
      )}

      {alertModal && (
        <Modal
          open={alertModal}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              position: "absolute",
              flexDirection: "column",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxWidth: 800,
              width: "90%",
              borderRadius: 2,
              border: "none",
              outline: "none",
              background: "white",
            }}
          >
            <div style={{ width: "100%", padding: 33 }}>
              <div style={{ padding: "2rem" }}>
                <div>
                  <div className="cus-icon cus-warning">
                    <span className="cus-body"></span>
                    <span className="cus-dot"></span>
                  </div>
                </div>

                <div className="d-flex justify-content-center align-items-center mt-3 ">
                  <h4 className="mt-2">
                    Please Add the Address From the Account section!
                  </h4>
                </div>
                <div className="d-flex justify-content-center align-items-center mt-1">
                  <button
                    type="button"
                    onClick={(e) => {
                      navigate("/profile");
                    }}
                    style={{
                      backgroundColor: "#00264d",
                      color: "white",
                      border: "none",
                      padding: "5px",
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: 8,
                      cursor: "pointer",
                      marginBottom: "10px",
                      marginTop: "20px",
                      maxWidth: 220,
                    }}
                  >
                    Go To Account
                  </button>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      )}

    </>
  )
}

export default Checkout